export default "__VITE_ASSET__D_wrNAE9__"